import { render, staticRenderFns } from "./NetworkInfoDialog.vue?vue&type=template&id=80e0704a&"
import script from "./NetworkInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./NetworkInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports